import { combineReducers } from "redux";
import { openingWarehouseSlice } from "./slices/openingWarehouseSlice";
import { festaSlice } from "./slices/festaSlice";
import { experienceSlice } from "./slices/experienceSlice";
import { parcelSlice } from "./slices/parcelSlice";

const rootReducer = combineReducers({
  product: openingWarehouseSlice.reducer,
  festaProduct: festaSlice.reducer,
  experience: experienceSlice.reducer,
  parcelProduct: parcelSlice.reducer,
});

export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>; // RootState 타입 정의
